import { safeboxClient } from 'myNet'

const ROUTE = '/v1/actions'

interface ApiResponse<T = any> {
  code: number
  message: string
  data?: T
}

interface ErrorWithCode extends Error {
  code: number
}

interface ActivityRequest {
  [key: string]: any
}

const ActivityService = {
  post: async (request: ActivityRequest): Promise<ApiResponse> => {
    const response = await safeboxClient.post(`${ROUTE}`, request)
    const { code, message } = response.data
    if (code !== 200) {
      const err = new Error(message) as ErrorWithCode
      err.code = code
      throw err
    }
    return response.data
  },

  // 레코드 1건의 변경 히스토리 (생성·수정·공유·소유권 이전, created_at DESC)
  getResourceActivities: async ({
    resourceId,
    limit = 20,
    offset = 0,
  }: {
    resourceId: string
    limit?: number
    offset?: number
  }): Promise<ApiResponse> => {
    const response = await safeboxClient.get(`/v1/resources/${resourceId}/activities`, {
      limit,
      offset,
    })
    const { code, message } = response.data
    if (code !== 200) {
      const err = new Error(message) as ErrorWithCode
      err.code = code
      throw err
    }
    return response.data
  },
}

export default ActivityService
